import ScanQrReferral from "components/allow-cookies/scanQr"
import { useState } from "react"
import textServices from "services/text-services"
import { ReferralInput } from "theme/theme"

export default function InputReferral({ setQR, ...rest }) {
  const [scanQr, setScanQr] = useState(false)

  return (
    <>
      {scanQr && <ScanQrReferral toggle={() => setScanQr(false)} setScanQrResult={setQR} />}
      <div className="w-full relative">
        <ReferralInput
          className="text-center saira font-bold text-sm"
          type="text"
          placeholder={textServices.findByText('profile/form/information/referral/placeholder', {
            es: 'Ingresa código referido',
            en: 'Enter referral code'
          })}
          onChange={(e) => setQR(e.currentTarget.value)}
          {...rest}
        />
        <button type="button" className="absolute z-10 right-4 top-0 bottom-0 referral-input-sign-up" onClick={() => setScanQr(true)}>
          <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.119141 0.649902H5.36914V5.8999H2.74414V7.2124H1.43164V5.8999H0.119141V0.649902ZM5.36914 5.8999H9.30664V0.649902H14.5566V5.8999H13.2441V7.2124H11.9316V5.8999H10.6191V7.2124H7.99414V8.5249H9.30664V9.8374H5.36914V15.0874H0.119141V9.8374H4.05664V8.5249H6.68164V7.2124H5.36914V5.8999ZM13.2441 7.2124H14.5566V8.5249H13.2441V7.2124ZM13.2441 8.5249V9.8374H11.9316V8.5249H13.2441ZM13.2441 9.8374H14.5566V11.1499H13.2441V9.8374ZM13.2441 11.1499V12.4624H12.5879V13.7749H11.2754V12.4624H8.65039V15.0874H7.33789V11.1499H10.6191V9.8374H11.9316V11.1499H13.2441ZM11.2754 13.7749V15.0874H9.96289V13.7749H11.2754ZM11.9316 8.5249H10.6191V7.2124H11.9316V8.5249ZM4.05664 8.5249H2.74414V7.2124H4.05664V8.5249ZM1.43164 7.2124V8.5249H0.119141V7.2124H1.43164ZM6.68164 0.649902H7.99414V1.9624H8.65039V3.2749H7.99414V5.24365H6.68164V4.5874H6.02539V3.2749H6.68164V0.649902ZM1.43164 1.9624V4.5874H4.05664V1.9624H1.43164ZM10.6191 1.9624V4.5874H13.2441V1.9624H10.6191ZM2.08789 2.61865H3.40039V3.93115H2.08789V2.61865ZM11.2754 2.61865H12.5879V3.93115H11.2754V2.61865ZM1.43164 11.1499V13.7749H4.05664V11.1499H1.43164ZM2.08789 11.8062H3.40039V13.1187H2.08789V11.8062ZM13.2441 13.7749H14.5566V15.0874H13.2441V13.7749Z" fill="#666666" />
          </svg>
        </button>
      </div>
    </>
  )
}